import { render, staticRenderFns } from "./ProductImages2.vue?vue&type=template&id=ccedbe46&scoped=true&"
import script from "./ProductImages2.vue?vue&type=script&lang=js&"
export * from "./ProductImages2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccedbe46",
  null
  
)

export default component.exports